import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/social-media/social_media_banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner cloud_cost_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Social Media Marketing Services
              </h1>
              <span>
                Engage Your Target Audience with Custom Social Media Marketing
                Services
              </span>
              <p style={{ marginTop: "10px" }}>
                We at Tekrevol offer you top-of-the-line social media marketing
                services that guarantee high engagement from your target
                audiences, drive traffic and generate meaningful new sales leads
                for your business.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Request a Quote
              </Link>
              <Link
                to="/projects"
                className="border_btn web_case_btn"
                aria-label="TekRevol Contact"
              >
                Case Studies
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
